import { sanitizeHtml } from "utils";
import {
  Body,
  Chevron,
  Container,
  DocHtml,
  Header,
  Loader,
  Name,
} from "./styledComponents";

type Props = {
  name: string;
  className?: string;
  expanded?: boolean;
  loading?: boolean;
  content?: string | null;
  onToggle?: () => void;
};

const DocumentListItem = ({
  name,
  className,
  expanded = false,
  loading = false,
  content,
  onToggle,
}: Props) => {
  return (
    <Container className={className}>
      <Header onClick={onToggle}>
        <Name>{name}</Name>
        <Chevron $expanded={expanded}>
          {loading ? <Loader /> : "▾"}
        </Chevron>
      </Header>
      {expanded && content && (
        <Body>
          <DocHtml dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
        </Body>
      )}
    </Container>
  );
};

export default DocumentListItem;
